/* =========================================================
	FIGCAPTION WIDTH
	Force the figcaption element to be the same width
	as the image in the figure
========================================================= */

let figures = document.querySelectorAll('figure.image');

if(typeof(figures) != 'undefined' && figures != null) {
	figures.forEach(function(figureEl) {
		let figImage = figureEl.querySelector('img');
		let figImageWidth = figImage.offsetWidth;
		let figcaption = figureEl.querySelector('figcaption');

		if(typeof(figcaption) != 'undefined' && figcaption != null) {
			figcaption.style.width = figImageWidth + 'px';
		}
	});
}
